// extracted by mini-css-extract-plugin
export var actionText = "_ri-4";
export var container = "_ri-0";
export var leftSection = "_ri-1";
export var rightSection = "_ri-2";
export var settingsButton = "_ri-6";
export var settingsIcon = "_ri-7";
export var shortcut = "_ri-5";
export var shortcutGroup = "_ri-3";